import { merge, set } from 'lodash'
import { http, id } from 'utils'
import { initialPlacementState } from './placements'
import { SET_PROPERTY, SET_PROGRAM, SET_PROGRAMS } from 'vx/mutations'
import graduates from './programs/graduates'

export const initialProgramState = () => ({
  name: null,
  status: 'draft',
  help_url: null,
  placements: [
    merge(initialPlacementState(), { number: 1 }),
    merge(initialPlacementState(), { number: 2 })
  ],
  open_date: null,
  due_date: null
})

export default {
  namespaced: true,

  modules: {
    graduates
  },

  state: {
    program: initialProgramState(),
    programs: []
  },

  getters: {
    programExists: state => state.program.id !== undefined && state.program.id !== null
  },

  actions: {
    async getProgram ({ commit }, programId) {
      const response = await http.get(`/programs/${id(programId)}`)

      commit(SET_PROGRAM, response.data.data)

      return response
    },

    async getPrograms ({ commit }, params = {}) {
      const response = await http.get('/programs', { params })

      commit(SET_PROGRAMS, response.data.data)

      return response
    },

    async storeProgram ({ commit }, payload) {
      const response = await http.post('/programs', payload)

      commit(SET_PROGRAM, response.data.data)

      return response
    },

    async activateManagers ({ commit }, { programId, placementId }) {
      const response = await http.post(`/programs/${programId}/placements/${placementId}/activate-managers`)
      return response
    },

    updateProgram ({ commit }, { program, payload }) {
      return http.put(`/programs/${id(program)}`, payload)
    },

    async archiveProgram ({ commit }, program) {
      const response = await http.delete(`/programs/${id(program)}`)
      return response
    },

    unArchiveProgram ({ commit }, programId) {
      return http.put(`/programs/${id(programId)}/restore`)
    },

    importProgramGraduates (store, { program, file }) {
      let payload = new FormData()

      payload.append('file', file)

      return http.post(`programs/${id(program)}/import-graduates`, payload)
    },

    setProgramProperty ({ commit }, payload) {
      commit(SET_PROPERTY, payload)
    },

    resetProgram ({ commit }) {
      commit(SET_PROGRAM, initialProgramState())
    },

    resetPrograms ({ commit }) {
      commit(SET_PROGRAMS, [])
    },

    updateProgramHelpUrl ({ commit }, { program, payload }) {
      commit(SET_PROPERTY, payload)
      return http.put(`/programs/${id(program)}/resources`, payload)
    }
  },

  mutations: {
    [SET_PROPERTY] (state, { property, value }) {
      set(state.program, property, value)
    },

    [SET_PROGRAM] (state, program) {
      state.program = program
    },

    [SET_PROGRAMS] (state, programs) {
      state.programs = programs
    }
  }
}
